import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Content} from 'shared/models/contents/content';
import {IContentsOverviewRepository} from './contents-overview.repository.interface';

@Injectable()
export class ContentsOverviewHttpRepository implements  IContentsOverviewRepository {

  constructor(private http: Http) { }

  public getContents(): Observable<Array<Content>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(environment.contents, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteContent(id: string): Observable<void> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.contents}/${id}`, options)
      .map((response: Response) => {
        return;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-overview/repositories/contents-overview.repository.http.ts